import clsx from 'clsx';
import React from 'react';

import styles from '@components/TITVPopout/styles.module.scss';
import useEventTracking from '@hooks/useEventTracking';
import { TrackingLocation } from '@tracking';
import type { LiveStream } from '@utils/backend-api/titv';

import EventStreamPlayer from '../EventStreamPlayer';
import { DAILY_SHOW_TITLE } from './constants';

interface TITVMultistreamFeatureLiveStreamProps {
  inProgressStream?: LiveStream;
}

const TITVMultistreamFeatureLiveStream = ({
  inProgressStream,
}: TITVMultistreamFeatureLiveStreamProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.TITVLiveStream,
  });

  if (!inProgressStream) return null;

  const shouldRenderTITVPresentsText = inProgressStream?.networkTitle !== DAILY_SHOW_TITLE;

  return (
    <Track>
      <article className="mx-auto mb-40 w-full max-w-container-lg border-0 border-b border-solid border-grayscale-beige pb-40 md:mb-72 md:pb-56">
        <span className="flex h-28 w-full flex-row items-center gap-4 bg-primary-magenta px-16 font-suisse-intl-mono text-overline-sm font-normal text-white">
          {' '}
          <div
            className={clsx(styles['animate-slow-blink'], 'block h-8 w-8 rounded-full bg-white')}
          />
          STREAMING NOW
        </span>
        <EventStreamPlayer inProgressStream={inProgressStream} />
        <header className="m-auto max-w-container-lg px-16 sm:px-28 xl:px-0">
          <h1 className="m-0 mt-40 font-suisse-works text-headline-sm font-normal text-primary-black md:text-headline-lg">
            {shouldRenderTITVPresentsText && 'The Information’s TITV Presents'}
            {shouldRenderTITVPresentsText && inProgressStream?.networkTitle && ': '}
            {inProgressStream?.networkTitle ? inProgressStream.networkTitle : ''}
          </h1>
          {inProgressStream.streamingTitle && (
            <p className="m-0 font-noto-serif text-body-lg font-normal text-grayscale-charcoal">
              {inProgressStream.streamingTitle}
            </p>
          )}
        </header>
      </article>
    </Track>
  );
};

export default TITVMultistreamFeatureLiveStream;
